<ng-container *transloco="let t">
	<vex-page-layout mode="card">
		<vex-page-layout-header class="flex-col !items-start">
			<div class="flex flex-col w-full">
				<h1 class="title mt-0 mb-6" name="dashboardTitle">{{ t('dashboard.welcome') + ' ' + firstName + ' ' + lastName }}</h1>
				<h2 class="text-base font-normal mt-0 mb-4 opacity-80">{{ t('dashboard.quickActionsHeading') }}</h2>
				<div class="flex flex-row flex-wrap items-stretch justify-start gap-3">
					<div class="quick-action-card" (click)="newTenantChange()">
						<mat-icon class="quick-action-icon">person_edit</mat-icon>
						<span class="quick-action-label">{{ t('tenantunitDetails.residentChange') }}</span>
					</div>
					<div class="quick-action-card" (click)="newVacancyChange()">
						<mat-icon class="quick-action-icon" fontSet="material-symbols-outlined">door_open</mat-icon>
						<span class="quick-action-label">{{ t('commonActions.newVacancy') }}</span>
					</div>
					<div class="quick-action-card" (click)="changeUviPermission()">
						<mat-icon class="quick-action-icon">shield_person</mat-icon>
						<span class="quick-action-label">{{ t('commonActions.changeUviPermission') }}</span>
					</div>
					<div class="quick-action-card" (click)="activateRealEstate()">
						<mat-icon class="quick-action-icon">add</mat-icon>
						<span class="quick-action-label">{{ t('commonActions.activateRealEstate') }}</span>
					</div>
				</div>
			</div>
		</vex-page-layout-header>
	</vex-page-layout>
</ng-container>
